module.exports = __webpack_public_path__ + "static/media/image8.503277f9.jpg";